export const rate_type = [
	{ label: 'In Amount', value: 'AMOUNT' },
	{ label: 'In Percentage', value: 'PERCENTAGE' },
];
